export default __webpack_public_path__ + "static/media/1.ff8dae02.png";